






























































































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import NavbarSupportMixin from '@/views/layout/navigation/mixins/navbar-support-mixin';
import PaymentStatusMixin from '@/views/layout/navigation/mixins/payment-status-mixin';

import UrlMixin from '@/components/query/url-mixin';
import config from '@/config';
import {logoutChatwootSession} from '@/services/utils/chatwoot';
import MenuItem from '@/components/menu/menu-item.vue';
import BookmarkListDialog from '@/components/bookmark/bookmark-list-dialog.vue';
import NavbarWorkspacesMenu from '@/views/layout/navigation/navbar-workspaces-menu.vue';
import NavbarEvents from '@/views/layout/navigation/navbar-events.vue';
import NavbarEventsMenu from '@/views/layout/navigation/navbar-events-menu.vue';
import NavbarBoostViewMenu from '@/views/layout/navigation/navbar-boost-view-menu.vue';
import MenuEventsMixin from '@/views/layout/navigation/mixins/menu-events-mixin';

@Component({
  components: {
    NavbarEventsMenu,
    NavbarBoostViewMenu,
    NavbarEvents,
    MenuItem,
    BookmarkListDialog,
    NavbarWorkspacesMenu
  }
})
export default class MainMenuMobileDrawer extends mixins(NavbarSupportMixin, MenuEventsMixin, UrlMixin, PaymentStatusMixin) {
  supportDropdown: boolean = false;
  workspaceDropdown: boolean = false;

  handleMobileDesktopViewForced() {
    this.toggleMobileDesktopViewForced();
    this.close();
  }

  handleOpenBookmarkListDialog() {
    const bookmarkListDialog = this.$refs.bookmarkListDialog as BookmarkListDialog;
    bookmarkListDialog.open();

    this.close();
  }

  get visibility() {
    return this.$store.state.mobile.menuOpen;
  }

  get $FFReportingBoostViewEnabled() {
    return this.$FF?.reportingBoostView?.enabled;
  }

  set visibility(value: boolean) {
    this.$store.commit('mobileMenuOpen', value);

    this.supportDropdown = window.innerHeight > 500;

    const cb = () => {
      var overlay: HTMLElement = document.querySelector('.v-overlay.v-overlay--absolute.v-overlay--active');
      if(!overlay) {
        return false;
      }

      overlay.style.zIndex = '1000';

      overlay.removeEventListener('click', this.handleOverlayClick);
      overlay.addEventListener('click', this.handleOverlayClick);

      return true;
    };

    if(value) {
      this.$helpers.afterBrowserRedraw(() => {
        if(!cb()) {
          // reserve event listener registration
          setTimeout(() => {
            if(!cb()) {
              console.error('can\'t register overlay event listener');
            }
          }, 700);
        }
      });
    }
  }
  
  handleQuickStartClick() {
    this.quickStart();
    this.close();
  }

  handleOverlayClick() {
    this.close();
  }

  handleOpenLiveSupportMobile() {
    this.handleOpenLiveSupport();
    this.close();
  }

  handleHelpCenterClick() {
    window.open(this.helpCenterLink, '_blank');
  }

  handleBlogClick() {
    window.open(config.blogLink, '_blank');
  }

  handleTemporaryPasswordClick() {
    this.bus.emit('open-dialog', { name: 'TemporaryPasswordDialog' });

    this.close();
  }

  handleReportsClick() {
    this.$router.push(this.defaultHomepage());
    this.close();
  }

  handleSettingsClick() {
    this.$router.push({
      name: 'app.profile'
    });

    this.close();
  }

  handleLogout() {
    if(this.$FF.chatwoot?.enabled){
      logoutChatwootSession();
    }else{
      this.$intercom?.hide();
      this.$intercom?.boot({'hide_default_launcher': true});
      this.$intercom?.update();
    }
    this.$router.push({
      name: 'logout'
    });

    this.close();
  }

  handlePayment() {
    this.$router.push('/app/profile/subscription')
    this.close();
  }

  close() {
    this.visibility = false;
  }
}
